import { DOMAIN_NAME } from 'frontend-utils/utils/constants/domain-utils';

const PAYMENTS_PRODUCTION_DOMAIN = `pay.${DOMAIN_NAME}`;
const PAYMENTS_STAGING_DOMAIN = `pay-staging.${DOMAIN_NAME}`;
const PAYMENTS_DEVELOPMENT_DOMAIN = 'localhost';

export const utilities = {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  checkDomain(hostname: string) {
    return {
      isDevelopment: hostname === PAYMENTS_DEVELOPMENT_DOMAIN,
      isProduction: hostname === PAYMENTS_PRODUCTION_DOMAIN,
      isStaging: hostname === PAYMENTS_STAGING_DOMAIN,
    };
  },
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getHostDomain() {
  const { isDevelopment, isProduction, isStaging } = utilities.checkDomain(
    window.location.hostname,
  );

  if (isProduction) {
    return `https://${PAYMENTS_PRODUCTION_DOMAIN}`;
  }

  if (isStaging) {
    return `https://${PAYMENTS_STAGING_DOMAIN}`;
  }

  if (isDevelopment) {
    return `https://pay-staging.mylighthouse.com`;
  }

  return `https://${window.location.hostname}`;
}
